import React from 'react';
import { statesByCountry } from '../../utils/locationData';
import { SelectField } from './SelectField';

interface StateSelectProps {
  country: string;
  value: string;
  onChange: (value: string) => void;
}

export function StateSelect({ country, value, onChange }: StateSelectProps) {
  const states = statesByCountry[country] || [];

  return (
    <SelectField
      id="state"
      label="State/Province/Region"
      value={value}
      onChange={onChange}
      options={states.map(state => ({
        value: state.code,
        label: state.name
      }))}
      placeholder="Select a state/province/region"
    />
  );
}